/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getAllLanguages } from '../fn/language-controller/get-all-languages';
import { GetAllLanguages$Params } from '../fn/language-controller/get-all-languages';
import { LanguageDto } from '../models/language-dto';

@Injectable({ providedIn: 'root' })
export class LanguageControllerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getAllLanguages()` */
  static readonly GetAllLanguagesPath = '/languages';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllLanguages()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllLanguages$Response(params?: GetAllLanguages$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LanguageDto>>> {
    return getAllLanguages(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllLanguages$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllLanguages(params?: GetAllLanguages$Params, context?: HttpContext): Observable<Array<LanguageDto>> {
    return this.getAllLanguages$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<LanguageDto>>): Array<LanguageDto> => r.body)
    );
  }

}
